'use client'
const getValueByKey = (objectData, keyName) => objectData[keyName];

export { getValueByKey };
